import Home from './Home.tag-generator.vue'

export default {
  Home
}